import { Input, Modal, Typography } from "antd";
import type React from "react";
import { useState } from "react";

const { Text } = Typography;

interface MFACodeModalProps {
  visible: boolean;
  onSubmit: (code: string) => void;
  onCancel: () => void;
  loading: boolean;
}

const MFACodeModal: React.FC<MFACodeModalProps> = ({ visible, onSubmit, onCancel, loading }) => {
  const [code, setCode] = useState("");

  const handleOk = () => {
    if (code.trim()) {
      onSubmit(code.trim());
    }
  };

  return (
    <Modal
      title="Enter Verification Code"
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Submit"
      cancelText="Cancel"
      okButtonProps={{ disabled: !code.trim(), loading }}
      cancelButtonProps={{ disabled: loading }}
      width={440}
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      zIndex={1000}
    >
      <div style={{ marginBottom: 16 }}>
        <Text>A verification code was sent to your email. Please enter it below to continue the transfer.</Text>
      </div>

      <Input
        placeholder="Enter verification code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        onPressEnter={handleOk}
        maxLength={10}
        size="large"
        autoFocus
        disabled={loading}
      />
    </Modal>
  );
};

export default MFACodeModal;
